import GTag from '../utils/GTag'
import Constants from './Constants'

export default class UI
{
    constructor(_options)
    {
        window.showSubItems = this.showSubItems

        this.database = _options.database
        this.sizes = _options.sizes
        this.time = _options.time

        Constants.VARS.slideMenuOpen = false

        this.submenuWines = document.getElementById('submenu_wines')
        this.submenuGrapes = document.getElementById('submenu_grapes')

        this.detailsDiv = document.getElementById('details_main')
        this.detailsTitle = document.getElementById('details_title_container')
        this.detailsDesc = document.getElementById('details_description_container')
        this.detailsBtn = document.getElementById('details_findmore_btn')

        this.footerList = document.querySelector('.footerListUl')
        this.footerListScrollFlag = false
        this.footerListDragFlag = false
        this.footerListScrollPosition = { left: 0, x: 0 }

        this.underlineDiv = document.createElement('div')

        this.fillMenuUrls()
        this.setGTag()
    }

    createHandlers()
    {
        // Switch
        document.querySelector('.switch_input').addEventListener('change', (e) => this.toggleMode(e.currentTarget.checked ? 'g' : 'w'))

        // Slide menu
        document.querySelector('.hamburger_btn').addEventListener('click', () => this.openSlideMenu())
        document.querySelector('.close_menu_div').addEventListener('click', () => this.closeSlideMenu())
        document.getElementById('menu_nav').querySelectorAll('a').forEach(x => x.addEventListener('click', () =>
        {
            this.interruptAutoclick()
        }))

        // Scroll footer
        this.sizes.on('resize', () => this.setArrowsVisibility())
        this.footerList.addEventListener('mousedown', (e) => this.footerListPointerDownHandler(e.clientX))
        document.addEventListener('mousemove', (e) => this.footerListPointerMoveHandler(e.clientX))
        document.addEventListener('mouseup', (e) => this.footerListPointerUpHandler())
        this.footerList.addEventListener('touchstart', (e) => this.footerListPointerDownHandler(e.touches[0].clientX))
        document.addEventListener('touchmove', (e) => this.footerListPointerMoveHandler(e.touches[0].clientX))
        document.addEventListener('touchend', (e) => this.footerListPointerUpHandler())

        document.querySelector('.arrow.left').addEventListener('click', () => this.arrowClickHandler(true))
        document.querySelector('.arrow.right').addEventListener('click', () => this.arrowClickHandler(false))
    }

    /**
     * Menu
     */
    fillMenuUrls()
    {
        this.database.wines.forEach(wine =>
        {
            this.createSubmenu(wine, this.submenuWines)
        })

        this.database.distinctGrapes.forEach(grape =>
        {
            this.createSubmenu(grape, this.submenuGrapes)
        })
    }

    createSubmenu(item, container)
    {
        const ol = document.createElement('ol')
        ol.className = 'sub_menu'

        const a = document.createElement('a')
        a.target = '_blank'
        a.href = item.permalink
        a.innerHTML = item.name
        a.dataset.gtag_label = item.name
        a.setAttribute('data-id', item.id)

        ol.appendChild(a)
        container.appendChild(ol)
    }

    setGTag()
    {
        this.detailsBtn.addEventListener('click', () => {
            const item = this.database.getItemFromId(parseInt(this.detailsBtn.dataset.itemId))
            GTag.add('click_on_scopri', { 'item': item.name })
        })

        const menuElements = [...document.querySelectorAll('#menu_list_container a')]
        menuElements.forEach(el => {
            const label = el.dataset.gtag_label
            if(label !== undefined && label !== null && label !== '')
            {
                el.addEventListener('click', () => {
                    GTag.add('click_on_menu', { 'item': label })
                })
            }
        })
    }

    /**
     * Renderer enable
     */
    enableRenderer()
    {
        document.getElementById('disable_overlay').style.opacity = '0'
        if(this.camera) this.camera.controls.enabled = true
    }

    disableRenderer()
    {
        document.getElementById('disable_overlay').style.opacity = '0.75'
        if(this.camera) this.camera.controls.enabled = false
    }

    /**
     * Slide Menu
     */
    openSlideMenu()
    {
        if(!Constants.VARS.slideMenuOpen)
        {
            Constants.VARS.slideMenuOpen = true
            document.getElementById('menu_nav').style.width = Constants.VARS.isMobile ? '90%' :'50%'
            this.disableRenderer()
        }
    }

    showSubItems(index){
        let arrowIcon = document.getElementsByClassName('listArrow')[index];
        let y = document.getElementsByClassName('subcategories')[index];

        if(y.style.display !== "block"){
            y.style.display = "block";

            arrowIcon.classList.replace('fa-chevron-left', 'fa-chevron-down');
        }
        else{
            y.style.display = "none";

            arrowIcon.classList.replace('fa-chevron-down', 'fa-chevron-left');
        }


    }

    closeSlideMenu()
    {
        if(Constants.VARS.slideMenuOpen)
        {
            Constants.VARS.slideMenuOpen = false
            document.getElementById('menu_nav').style.width = '0'
            this.enableRenderer()
        }
    }

    /**
     * Footer List
     */
    footerListMouseLeave()
    {

        this.footerList.querySelectorAll('a').forEach(link =>
        {
            link.addEventListener('mouseleave', e =>
            {
                link.classList.add('animate-out')
                link.ontransitionend = () =>
                {
                    link.classList.remove('animate-out')
                }
            })
        })
    }

    setArrowsVisibility(currentScroll)
    {
        if(currentScroll === undefined) currentScroll = this.footerList.scrollLeft
        if(currentScroll <= 0)
        {
            // Scrolled to start
            document.querySelector('.arrow.left').classList.add('hidden')
        }
        else
        {
            document.querySelector('.arrow.left').classList.remove('hidden')
        }
        if(this.footerList.scrollWidth - currentScroll <= this.footerList.clientWidth)
        {
            // Scrolled to end
            document.querySelector('.arrow.right').classList.add('hidden')
        }
        else
        {
            document.querySelector('.arrow.right').classList.remove('hidden')
        }
    }

    arrowClickHandler(left)
    {
        const scrollValue = (left ? -1 : 1) * this.footerList.clientWidth * (Constants.VARS.isMobile ? 0.75 : 0.4)
        this.footerList.scrollBy({ left: scrollValue, behavior: 'smooth' })
        this.setArrowsVisibility(this.footerList.scrollLeft + scrollValue)
    }

    footerListPointerDownHandler(clientX)
    {
        this.footerListScrollFlag = true
        this.footerListDragFlag = false
        this.footerListScrollPosition = { left: this.footerList.scrollLeft, x: clientX }
    }

    footerListPointerMoveHandler(clientX)
    {
        this.footerListDragFlag = true
        if(this.footerListScrollFlag)
        {
            const dx = clientX - this.footerListScrollPosition.x
            this.footerList.scrollLeft = this.footerListScrollPosition.left - dx
            this.setArrowsVisibility(this.footerList.scrollLeft)
        }
    }

    footerListPointerUpHandler()
    {
        this.footerListScrollFlag = false
    }

    emptyFooterList()
    {
        this.footerList.innerHTML = ''
    }

    createWineButtons()
    {
        for(let wine of this.database.wines)
        {
            const a = document.createElement('a')
            a.innerText = wine.name

            const li = document.createElement('li')
            li.appendChild(a)
            li.addEventListener('click', () => { if(this.megaRaycaster && !this.footerListDragFlag) this.megaRaycaster.footerListClick(wine.id) })
            this.footerList.appendChild(li)
        }
        this.footerListMouseLeave()
    }

    createGrapeButtons()
    {
        for(let grape of this.database.distinctGrapes)
        {
            const a = document.createElement('a')
            a.innerText = grape.name

            const li = document.createElement('li')
            li.appendChild(a)
            li.addEventListener('click', () => { if(this.megaRaycaster && !this.footerListDragFlag) this.megaRaycaster.footerListClick(grape.id) })
            this.footerList.appendChild(li)
        }
        this.footerListMouseLeave()
    }

    /**
     * Mode Switch
     */
    toggleMode(mode)
    {
        this.interruptAutoclick()

        if(this.megaRaycaster) this.megaRaycaster.unclick()
        this.emptyFooterList()
        mode === 'w' ? this.createWineButtons() : this.createGrapeButtons()
        this.setArrowsVisibility()

        Constants.VARS.mode = mode
        if(this.layout !== undefined)
        {
            this.layout.updateEnabledMaterials()
        }

        GTag.add('click_on_switch', { 'to_mode': mode === 'w' ? 'wines' : 'grapes' })
    }

    /**
     * Details
     */
    showDetails(itemId)
    {
        const item = this.database.getDisplayItemFromId(itemId)

        this.detailsDiv.classList.add('visible')
        if(this.detailsTitle) this.detailsTitle.textContent = item.name
        if(this.detailsDesc) this.detailsDesc.innerHTML = item.description
        if(this.detailsBtn) {
            this.detailsBtn.href = this.database.getPermalink(itemId)
            this.detailsBtn.dataset.itemId = itemId
        }
    }

    hideDetails()
    {
        this.detailsDiv.classList.remove('visible')
    }

    /**
     * Auto click
     */
    setAutoclick()
    {
        this.autoclickAnimation()
        setTimeout(() =>
        {
            if(!Constants.VARS.firstInteraction)
            {
                Constants.VARS.hasAutoclicked = true
                this.megaRaycaster.manageClick(this.database.getDefaultWineId())
            }
        }, 7000)
    }

    autoclickAnimation()
    {
        this.underlineDiv.className = 'hand_underline'
        this.footerList.children[0].appendChild(this.underlineDiv)
        setTimeout(() => this.underlineDiv.style.width = '100%', 10)
    }

    interruptAutoclick()
    {
        if(!Constants.VARS.firstInteraction)
        {
            Constants.VARS.firstInteraction = true
            this.underlineDiv.style.opacity = '0'
        }
    }
}